<template>
  <div id="kakaoHead" role="banner" :class="['k_head',{ k_head_sub : isSubPage }]">
    <div class="inner_head">
      <h1 class="tit_logo">
        <router-link :to='$routerPath.HOME' id="kakaoServiceLogo" class="link_logo">
          <img src="https://t1.kakaocdn.net/smartfactory/images/service/pc/service_logo.png" class="img_g" alt="T-Fac">
        </router-link>
      </h1>
      <div class="service_brand">
        <button class="btn_service line_type" @click="clickService">서비스 이동</button>
<!--        <button class="btn_service" @click="clickServiceReg">서비스 신청</button>-->
      </div>
      <div id="kakaoGnb" role="navigation" class="gnb_brand">
        <h2 class="screen_out">서비스 메뉴</h2>
        <ul class="list_gnb">
          <MenuItem v-for="item in menuData" :key='item.menuId'
            :title='item.title'
            :link='item.link'
            :arrSub='item.arrSub'
            :selected='selectedMenuId === item.menuId'
            :selectedSubId='selectedMenuSubId' />
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import MenuItem from './MenuItem'
import { menus } from '@/constants/menus'
// import { menuData as menuDataUser } from '@/constants/supply/menuData'
// import LocalStorageManager from '~/storages/LocalStorageManager'
// import ApiService from '@/services/ApiService'
// import { getMenuData } from '~/utils/spUtils'

// import { mapState } from 'vuex';

import Api from '../../../api/serviceApi'
import TiaraService from "@/plugins/TiaraService";

const tiaraService = TiaraService.getService();

export default {
  name: 'Header',
  components: {
    MenuItem
  },
  mounted() {
    const menuId = this.$route.meta.menuId;
    this.selectedMenuId = menuId;

    const subMenuId = this.$route.meta.subMenuId;
    if( subMenuId ){
      this.selectedMenuSubId = subMenuId;
    }
  },
  beforeMount() {
    // this.menuData = getMenuData();
    this.menuData = menus;
  },
  data() {
    return {
      selectedMenuId: null,
      selectedMenuSubId: null,
      menuData: null,
      isBoxProfile: false
    }
  },
  computed: {
    isSubPage(){
      // console.log(this.$route.name)
      if(this.$route.name === 'Home') {
        return false;
      } else if(this.$route.name === 'Introduce') {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    async clickServiceReg(){
      /*this.$router.push({
        path: this.$routerPath.JOIN
      })*/
      try {
        const response = await Api.serviceReg();
        // alert(response.data.result[0].kakaoLoginUrl)

        location.href = response.data.result[0].kakaoLoginUrl;
      } catch (error) {
        //
      }
    },
    async clickService() {
      /*
      try {
        const response = await Api.login();
        location.href = response.data.result[0].kakaoLoginUrl;
      } catch (error) {
        //
      }
      */
      tiaraService.trackEvent('서비스이동_클릭')
      location.href = process.env.VUE_APP_SERVICE_URL;
    },
    // onClickProfile(){
    //   this.isBoxProfile = !this.isBoxProfile;
    // },
    // async onClickLogout() {
      // const result = await ApiService.shared.getData( this.$apiPath.LOGOUT );
      // 그냥 결과에 대한 처리 안함.
      // if( result.code !== '200' )

      // 일단 나중에.
      // const isAdmin = LocalStorageManager.shared.getIsAdmin();

      // const path = isAdmin ? this.$routerPath.LOGIN_ADMIN : this.$routerPath.LOGIN;

      // LocalStorageManager.shared.clear();

      // this.$router.push( { path } );
    // }
  }
}
</script>

<style scoped>
.k_head{position:fixed;left:0;right:0;z-index:999;height:80px}
.k_head .inner_head{overflow:hidden;width:1080px;margin:0 auto}
.k_head .tit_logo{float:left;padding:17px 0 25px 0}
.k_head .tit_logo .link_logo{display:block;padding:0}
.k_head .tit_logo .img_g{width:124px;height:44px}

.k_head_sub{box-shadow:0 .5px 0 0 rgba(0,0,0,.12)}

/* -- gnb -- */
.gnb_brand{margin-left:317px}
.gnb_brand .list_gnb{display:inline-block;vertical-align:top}

/* service_brand */
.service_brand{float:right;padding:19px 0 21px;}
.service_brand .btn_login{display:inline-block;margin:10px 28px 10px 0;font-family:'NotoSansKR_M', sans-serif;font-size:14px;line-height:20px;color:#555}
.service_brand .btn_service{display:inline-block;height:40px;padding:9px 16px 11px;border-radius:3px;font-family:'NotoSansKR_M', sans-serif;font-size:14px;line-height:20px;background-color:#222;color:#fff}
.service_brand .btn_service.line_type{margin-right:12px;border:1px solid #222;background-color:transparent;color:#222}

</style>
